"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOLS_CATEGORY_FRAGMENT = exports.getNestedCategories = exports.RECURSIVE_REFERENCE_FRAGMENT = exports.DOC_TYPE_REGISTERED_DEVICES = exports.DOC_TYPE_QUOTATIONS = exports.DOC_TYPE_REQUESTS = exports.DOC_TYPE_TEAM = exports.DOC_TYPE_USER = exports.ORDER_CREATED_ASC = exports.ORDER_CREATED_DESC = exports.NOT_DRAFT = void 0;
/** Only return documents that are not in draft mode */
exports.NOT_DRAFT = ` !(_id in path("drafts.**")) `;
/** The newest documents will be at top */
exports.ORDER_CREATED_DESC = ' order(_createdAt desc) ';
/** The oldest documents will be at top */
exports.ORDER_CREATED_ASC = ' order(_createdAt asc) ';
exports.DOC_TYPE_USER = ` _type=="user" `;
exports.DOC_TYPE_TEAM = ` _type=="teams" `;
exports.DOC_TYPE_REQUESTS = ` _type=="requests" `;
exports.DOC_TYPE_QUOTATIONS = ` _type=="quotations" `;
exports.DOC_TYPE_REGISTERED_DEVICES = ` _type=="registeredDevices" `;
const RECURSIVE_REFERENCE_FRAGMENT = (key, depth, fragment) => {
    // eslint-disable-next-line prefer-spread
    const depthArray = Array.apply(null, Array(depth));
    return depthArray.reduce((acc) => {
        return `${key}->{
          ${fragment},
          ${acc}
    }`;
    }, '');
};
exports.RECURSIVE_REFERENCE_FRAGMENT = RECURSIVE_REFERENCE_FRAGMENT;
/**
 *  #### Retrieves the category hierarchy in a sorted array
 * ```
 *  grand parent -> parent -> child
 * ```
 *
 * @param {string} length - The depth in which it should retrieve the hierarchy
 * @param {string} customKey - A custom key of the category depending on the documents' schema
 **/
const getNestedCategories = (length, customKey = 'category') => {
    let query = `${customKey}->{_id, title, "slug": slug.current, "sortIndex": ${length + 1}},`;
    for (let i = 1; i < length; i++) {
        const parents = Array(i).fill('parent').join('->');
        query += `category->${parents}->{_id, title, "slug": slug.current, "sortIndex": ${length - i}},`;
    }
    return `[${query}][defined(_id)]  | order(sortIndex)`;
};
exports.getNestedCategories = getNestedCategories;
/**
 * returns a groq query fragment that contains the format for the `getNestedCategories` function:
 * ```
 * "categories": [{
 *   title:string
 *   slug:string
 *   sortIndex: number
 * }]
 * ```
 **/
exports.TOOLS_CATEGORY_FRAGMENT = `
  _type == "toolsCategory" => {
    "categories":${exports.getNestedCategories(5, 'parent')}
  },
  _type == "toolsProduct" => {
    "categories":${exports.getNestedCategories(5)}
  },
`;
//# sourceMappingURL=query.js.map